import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    flexGrow: 1,

    '& .btn-retry': {
      margin: theme.spacing(3, 0, 0),
    },
  },
}));

export default styles;
